import React, { useState } from "react";


const Footer = () => {
  const [bgStyle] = useState();


  return (
    <div>
      <footer style={bgStyle} className="bg-transparent bgstyle font-weight-bold text-light mt-auto py-4 text-center footername">
        <p></p>

        <i className="fas fa-code"></i> Created by{" "} Scott Caputo using React and Bootstrap

        <p>
          <small className="text-muted font-weight-bold">
            {" "}
            “Be the change that you wish to see in the world.” – Mahatma Gandhi
          </small>
        </p>
      </footer>
    </div>
  );
};

export default Footer;